import {ReactElement} from 'react'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import messages from '../../../../../../../assets/messages'
import {formatNumber} from '../../../../../../../common/utils'
import Amount from '../../../../../../Common/Amount'
import {useStatistics} from '../../hooks/useStatistics'
import {AmountClassNames} from '../../types'
import {GridSection} from '../GridSection'
import {LoadingLayout} from '../LoadingLayout'
import {ErrorLayout} from '../ErrorLayout'


type MonthlyStatisticsPropsBase = {
  accountId: number
  selectedDate: string
  amountClassNames: AmountClassNames
}

type MonthlyStatisticsProps = MonthlyStatisticsPropsBase & WithNamespaces

const Component = (props: MonthlyStatisticsProps): ReactElement => {
  const {lng, accountId, selectedDate, amountClassNames} = props

  const monthlyStatistics = useStatistics(accountId, selectedDate)

  if (monthlyStatistics.loading) return <LoadingLayout />
  if (monthlyStatistics.error || !monthlyStatistics.data) return <ErrorLayout scope='stats' />

  const {
    totalFollowers,
    losingTrades,
    winningTrades,
    totalProfit,
    totalPerformanceFee,
    currency
  } = monthlyStatistics.data.statistics

  return (
    <GridSection
      title={<Trans {...messages.providerStats} />}
      items={[
        {
          id: messages.monthlyFollowersCount.i18nKey,
          caption: <Trans {...messages.monthlyFollowersCount} />,
          value: formatNumber(lng, totalFollowers)
        },
        {
          id: messages.monthlyLosingTradesCount.i18nKey,
          caption: <Trans {...messages.monthlyLosingTradesCount} />,
          value: formatNumber(lng, losingTrades)
        },
        {
          id: messages.monthlyWinningTradesCount.i18nKey,
          caption: <Trans {...messages.monthlyWinningTradesCount} />,
          value: formatNumber(lng, winningTrades)
        },
        {
          id: messages.monthlyCopiedPnl.i18nKey,
          caption: <Trans {...messages.monthlyCopiedPnl} />,
          value: <Amount value={totalProfit} currency={currency} locale='en-US' classes={amountClassNames} />
        },
        {
          id: messages.monthlyPerformanceFee.i18nKey,
          caption: <Trans {...messages.monthlyPerformanceFee} />,
          value: <Amount value={totalPerformanceFee} currency={currency} locale='en-US' classes={amountClassNames} />
        }
      ]}
    />
  )
}

export const MonthlyStatistics = withNamespaces()(Component)

